import React, { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import "../css/contact.css";
import ConsentCheckbox from "./ConsentCheckbox";
export const ContactBanner = () => {
  return (
    <div className="container">
      <div className="banner-container">
        <div className="banner-img">
          <img
            className="desktop-view"
            src="/assets/contactBanner.webp"
            alt="banner"
          />
          <img
            className="mobile-view"
            src="/assets/contactusBannerMob.webp"
            alt="banner"
          />
        </div>
      </div>
    </div>
  );
};

export const ContactForm = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [consentChecked, setConsentChecked] = useState(false);
  const [btntext, setBtntxt] = useState({ message: "Submit →", type: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!consentChecked) {
      alert("Please agree to the Terms & Conditions and Privacy Policy to proceed.");
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (response) => {
          setBtntxt({ message: "Submitted", type: "disabled" });
          setFormData({ name: "", company: "", email: "", message: "" });
        },
        (error) => {
          alert("Failed to send message, please try again.");
        }
      );
  };

  return (
    <div className="container">
      <div className="heading-page">
        <h1 className="home-heading">
          <img src="/assets/icons/flag.svg" alt="" />
          <span className="heading-red">CONNECT</span>
          <br />
        </h1>
        <span className="heading-nextline">& COLLABORATE</span>
      </div>
      <div className="contact-form">
        <p className="quote">
          Reach out to our team for personalized solutions tailored to your
          commercial property investments and operations.
        </p>
        <form className="form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="name">
              <i className="icon-user">
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.12773 22.9841C6.63137 22.0095 8.13501 21.2855 9.63866 20.8122C11.1423 20.3388 12.7712 20.1021 14.5255 20.1021C16.2797 20.1021 17.9087 20.3388 19.4123 20.8122C20.916 21.2855 22.4196 22.0095 23.9233 22.9841C25.0649 21.8424 25.956 20.5059 26.5964 18.9744C27.2368 17.4429 27.5571 15.7861 27.5571 14.004C27.5571 10.3933 26.2869 7.31865 23.7466 4.78C21.2063 2.24163 18.1294 0.972442 14.5159 0.972442C10.9024 0.972442 7.82872 2.24163 5.2948 4.78C2.76088 7.31865 1.49393 10.3933 1.49393 14.004C1.49393 15.7861 1.81415 17.4429 2.45459 18.9744C3.09503 20.5059 3.98607 21.8424 5.12773 22.9841ZM14.5267 15.9253C13.1615 15.9253 11.9985 15.4454 11.0379 14.4856C10.0772 13.5258 9.59689 12.3632 9.59689 10.998C9.59689 9.63273 10.0768 8.46977 11.0366 7.50911C11.9964 6.54845 13.159 6.06812 14.5242 6.06812C15.8895 6.06812 17.0524 6.54803 18.0131 7.50785C18.9738 8.46768 19.4541 9.63022 19.4541 10.9955C19.4541 12.3607 18.9742 13.5237 18.0144 14.4843C17.0545 15.445 15.892 15.9253 14.5267 15.9253ZM14.5372 27.8709C12.6081 27.8709 10.8012 27.5159 9.11656 26.8059C7.43192 26.0958 5.95612 25.1073 4.68917 23.8403C3.42221 22.5734 2.4337 21.0981 1.72365 19.4146C1.0136 17.7311 0.658569 15.9212 0.658569 13.9848C0.658569 12.0484 1.0136 10.2449 1.72365 8.57419C2.4337 6.90348 3.42221 5.43464 4.68917 4.16768C5.95612 2.90072 7.43136 1.91222 9.11489 1.20216C10.7984 0.492112 12.6083 0.137085 14.5447 0.137085C16.4811 0.137085 18.2846 0.492112 19.9553 1.20216C21.626 1.91222 23.0949 2.90072 24.3618 4.16768C25.6288 5.43464 26.6173 6.90654 27.3273 8.58338C28.0374 10.2605 28.3924 12.0635 28.3924 13.9923C28.3924 15.9214 28.0374 17.7283 27.3273 19.4129C26.6173 21.0976 25.6288 22.5734 24.3618 23.8403C23.0949 25.1073 21.623 26.0958 19.9461 26.8059C18.269 27.5159 16.466 27.8709 14.5372 27.8709ZM14.5255 27.0356C16.057 27.0356 17.6094 26.7362 19.1826 26.1376C20.7559 25.5389 22.1272 24.7105 23.2967 23.6524C22.0994 22.817 20.7559 22.1557 19.2661 21.6684C17.7764 21.1811 16.1962 20.9375 14.5255 20.9375C12.8548 20.9375 11.2606 21.1672 9.74307 21.6266C8.22551 22.0861 6.8959 22.7613 5.75425 23.6524C6.92375 24.7105 8.29512 25.5389 9.86838 26.1376C11.4416 26.7362 12.994 27.0356 14.5255 27.0356ZM14.5255 15.09C15.6393 15.09 16.6 14.6862 17.4075 13.8787C18.215 13.0712 18.6187 12.1105 18.6187 10.9967C18.6187 9.88291 18.215 8.92225 17.4075 8.11474C16.6 7.30723 15.6393 6.90348 14.5255 6.90348C13.4117 6.90348 12.451 7.30723 11.6435 8.11474C10.836 8.92225 10.4322 9.88291 10.4322 10.9967C10.4322 12.1105 10.836 13.0712 11.6435 13.8787C12.451 14.6862 13.4117 15.09 14.5255 15.09Z"
                    fill="#0047BD"
                  />
                </svg>
              </i>
              <input
                type="text"
                id="name"
                name="name"
                required
                placeholder="FULL NAME"
                className="input"
                value={formData.name}
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="input-group">
            <label htmlFor="company">
              <i className="icon-email">
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.393188 23.5971V6.3171H5.83572V0.874573H17.6732V11.7596H23.1157V23.5971H13.9995V18.1546H9.50942V23.5971H0.393188ZM1.34563 22.6447H5.83572V18.1546H1.34563V22.6447ZM1.34563 17.2022H5.83572V12.7121H1.34563V17.2022ZM1.34563 11.7596H5.83572V7.26954H1.34563V11.7596ZM6.78816 17.2022H11.2782V12.7121H6.78816V17.2022ZM6.78816 11.7596H11.2782V7.26954H6.78816V11.7596ZM6.78816 6.3171H11.2782V1.82702H6.78816V6.3171ZM12.2307 17.2022H16.7208V12.7121H12.2307V17.2022ZM12.2307 11.7596H16.7208V7.26954H12.2307V11.7596ZM12.2307 6.3171H16.7208V1.82702H12.2307V6.3171ZM17.6732 22.6447H22.1633V18.1546H17.6732V22.6447ZM17.6732 17.2022H22.1633V12.7121H17.6732V17.2022Z"
                    fill="#0047BD"
                  />
                </svg>
              </i>
              <input
                type="company"
                id="company"
                name="company"
                placeholder="COMPANY NAME"
                required
                className="input"
                value={formData.company}
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="input-group">
            <label htmlFor="email">
              <i className="icon-email">
                <svg
                  width="29"
                  height="35"
                  viewBox="0 0 29 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.18412 19.4443V18.776H13.867V19.4443H7.18412ZM5.17926 15.4346V14.7663H15.8718V15.4346H5.17926ZM0.668335 31.9746V0.231079H20.3828V31.9746H0.668335ZM1.50369 28.0485V31.1393H19.5474V28.0485H1.50369ZM1.50369 27.2131H19.5474V4.99261H1.50369V27.2131ZM1.50369 4.15726H19.5474V1.06644H1.50369V4.15726Z"
                    fill="#0047BD"
                  />
                </svg>
              </i>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="WORK EMAIL"
                className="input"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </label>
          </div>
          <div className="input-group">
            <label htmlFor="message" className="sr-only">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="How can our team help you..."
              className="textarea"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <ConsentCheckbox
            checked={consentChecked}
            onChange={(e) => setConsentChecked(e.target.checked)}
          />
          <button type="submit" className={`submit-btn ${btntext.type}`}>
            {btntext.message}
          </button>
        </form>
      </div>
    </div>
  );
};
